module.exports = __webpack_public_path__ + "img/mask_3.ec72ff01.png";